/**

业务服务公共
ajax1--对异步请求的公共处理方法的封装
  ajax1.isOK(res,this);
  ajax1.catch1(errorMsg,vue);

self.$axios.post('rest/index/loginByVisitor.json',{}).then((res) => {
    if(res.data.code==200){
    }else{
      alert(res.data.msg);
    }
    console.log(res);

}).catch(function (error) {
console.log(error);
});
*/
import objectUtil from './objectUtil.js'
import localCacheMemory from './localCacheMemory.js'
window.localCacheMemory = localCacheMemory
import { pgMessageBoxAsync } from 'pangu-components-plus'
export default {
  /**
    异步请求的公共方法分组
    */
  ajax1: {
    /**
            异步请求，请求状态码成功情况下，公共处理方法，提示错误信息
            @method isOK
            @param {Object} res  异步返回对象
            @param {Vue} vue  vue模板对象
            @return {void} 返回值说明
        */
    isOK(res, vue, maskClosable = true) {
      if (!res.data) {
        if (vue.GLOBAL.isDebug) console.log('isOK:res.data is null', res)
        return false
      }
      if (res.data.code == 200) {
        return true
      } else {
        var errorMsg = res.data.msg
        if (errorMsg === undefined) {
          if (vue.GLOBAL.isDebug) console.error('ajax1.isOK(res)', res)
          errorMsg = '请求接口协议不正确，地址：' + res.config.url
        }
        if (vue && vue.$pgMessage) {
          vue.$pgMessage.confirm({
            title: '提示',
            content: errorMsg,
            maskClosable: maskClosable,
          })
          return false
        } else {
          if (vue.GLOBAL.isDebug) console.log(errorMsg)
        }
        if (vue && vue.$Message) {
          vue.$Message.error(errorMsg)
          return false
        } else {
          if (vue.GLOBAL.isDebug) console.log(errorMsg)
        }
      }
      return false
    },
    /**
          异步请求，异常公共处理方法，提示错误信息
          @method isOK
          @param {Object} res  异步返回对象
          @param {Vue} vue  vue模板对象
          @return {void} 返回值说明
        */
    catch1(error, vue) {
      if (vue.GLOBAL.isDebug) console.log(vue)

      if (vue.GLOBAL.isDebug) console.log('catch1', error)

      // 超时已由全局拦截器统一处理。
      if (error.response && error.response.status == '401') {
        if (vue.GLOBAL.isDebug) console.log('ssoRequest.axios.interceptorsOfResponse_catch do it')
        return
      }

      var errorMsg = null
      if (error.response && error.response.data && error.response.data.msg) {
        errorMsg = error.response.data.msg
      } else if (error.config) {
        errorMsg = error.config.url + '：无响应,原因：' + error.message
      } else {
        errorMsg = '请求服务器失败:' + error
      }

      if (vue && vue.$pgMessage) {
        vue.$pgMessage.confirm({
          title: '提示',
          content: errorMsg,
        })
        return false
      } else {
        alert(errorMsg)
        return false
      }
      // if (vue && vue.$Message) {
      //   vue.$Message.error(errorMsg);
      //   return;
      // } else {
      //   alert(errorMsg);
      //   return;
      // }
    },
  },
  formModify: {
    async switchRouteHandle(tabId, callback, vue) {
      // debugger;
      if (!tabId || !vue.$store.state.formModifyStore) return callback()

      var modifyMap = vue.$store.state.formModifyStore.modifyMap
      if (!modifyMap[tabId]) return callback()
      const { onClose, type } = await pgMessageBoxAsync({
        message: '有数据未保存，确认放弃当前页面？',
      })
      onClose()
      if (type) {
        vue.$store.commit('clearFormModifyBy', tabId)
        if (callback) callback()
      }
    },
  },
  // 是否启用<keep-alive /> 组件缓存
  useKeepAlive: false,
  // 设置数据缓存
  setLocalCacheMemory(routeId, $data, vue) {
    if (!this.useKeepAlive) {
      if (!routeId || typeof $data !== 'object' || !vue) return
      const pageList = vue.$store.state.menuStore.pageOpenedList
      const pageIsExist = pageList.some((item) => routeId.indexOf(item.id) > -1)
      if (pageIsExist) {
        const start = Date.now()
        console.info('start...', start)
        window.localCacheMemory.setItem(routeId, objectUtil.clone($data))
        const end = Date.now()
        console.info('end...', end, '保存缓存数据用时：', end - start, 'ms')
      }
    }
  },
  needCache: false,
  setNeedCache(val = true, id) {
    // this.needCache = true;
    if (window.localCacheMemory.ifExistCache(id)) {
      // 根据id判断存在缓存时才启用取缓存
      this.needCache = val
      this.needCacheArr = []
    }
  },
  needCacheArr: [], // 调转时该路由下已经获取过缓存的组件
  // 获取缓存数据，并给组件实例状态赋值缓存数据 //isreturn为true时直接将缓存的值return出去
  getLocalCacheMemory(routeId, vue, needFreeze = [], exclude = [], isCrudEdit, isreturn = false) {
    if (!this.useKeepAlive) {
      if (!routeId || !vue) return false
      // if (routeId.indexOf('[') === -1 && !this.needCache) {
      //     window.localCacheMemory.keys((value, key, index) => {
      //         if (key.indexOf(routeId) > -1) {
      //             window.localCacheMemory.removeItem(key);
      //         }
      //     })
      // }
      if (!this.needCache) {
        window.localCacheMemory.removeItem(routeId)
        return false
      }
      this.needCacheArr.push(routeId)
      if (window.localCacheMemory.ifIdChildren(routeId, this.needCacheArr)) {
        this.needCache = false
        this.needCacheArr = []
      }
      // if(!this.needCache) return
      // if(routeId.indexOf('[') === -1) this.needCache = false;

      const start = Date.now()
      console.info('start...', start)
      const $data = window.localCacheMemory.getItem(routeId)
      if (isreturn) return $data
      let res
      if ($data) {
        const end = Date.now()
        console.info('end...', end, '获取缓存数据用时：', end - start, 'ms')
        vue.pLoading = true
        for (let item in $data) {
          if (needFreeze.indexOf(item) > -1) {
            vue[item] = objectUtil.deepFreeze($data[item])
          } else if (exclude.indexOf(item) > -1) {
            continue
          } else {
            if (item == 'store') {
              // 设置store的缓存数据时只需缓存states(状态数据)
              if ($data[item] && $data[item].states && vue.store && vue.store.states) {
                vue[item].states = Object.assign(vue.store.states, $data[item].states)
              }
            } else if (isCrudEdit && item === 'formData') {
              // 缓存数据时 对表单的字段做一个特殊处理，不放入vue数据监听
              const filters = vue.definitionList.filter((im) => im.type === 'crudArrayOrder')
              if (filters.length > 0) {
                const crudAO = {}
                filters.forEach((fItem) => {
                  crudAO[fItem.property] = $data[item][fItem.property] || []
                  delete $data[item][fItem.property]
                })
                let _flashAddMedical = $data[item]._flashAddMedical || []
                let _flashAddMedicalForProduct = $data[item]._flashAddMedicalForProduct || []
                delete $data[item]._flashAddMedical
                delete $data[item]._flashAddMedicalForProduct
                vue[item] = $data[item]
                vue.store.commit('setFormData', vue[item])
                vue.refreshDynamicFrom = false
                vue.$nextTick(() => {
                  for (let field in crudAO) {
                    vue.formData[field] = crudAO[field].map((im) => {
                      im._ID = im._ID || objectUtil.createID()
                      return im
                    })
                  }
                  vue.formData._flashAddMedical = _flashAddMedical
                  vue.formData._flashAddMedicalForProduct = _flashAddMedicalForProduct
                  vue.refreshDynamicFrom = true
                  vue.$nextTick(() => {
                    vue.$refs.formRef.formControl()
                  })
                })
              } else {
                vue[item] = $data[item]
                vue.store.commit('setFormData', vue[item])
                vue.$nextTick(() => {
                  vue.$refs.formRef.formControl()
                })
              }
            } else {
              vue[item] = $data[item]
            }
          }
        }

        if (routeId.indexOf('[') === -1) {
          setTimeout(() => {
            vue.pLoading = false
            console.info('vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv')
          }, 10)
        }
        res = true
      } else {
        res = false
      }
      return res
    }
  },
  /**
   * copyData 复制选中行数据到剪贴板
   * @param [] 选中的行的内容
   * @param {} vue crudArrayOrder组件
   * 思路：将选中的表格行的数据转换成字符串，放入input组件中，自动执行选中此内容，再执行document的复制方法，将数据添加到剪贴板
   */
  copyData(content, vue) {
    if (!content) {
      alert('没有选中数据')
      return false
    }
    let strContent = JSON.stringify(content)
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.value = strContent
    input.select()
    document.execCommand('Copy', false)
    input.remove()
    vue.$Message.success('复制成功')
  },
  // 表格内右键点击粘贴
  /**
   * onTableRightPaste 表格行右键点击事件
   * @param {*} tableDom 操作的tableDom元素
   * @param {*} vue crudArrayOrder组件
   * 思路：此事件在复制按钮存在时才会声明，一共注册三个事件
   * 1.onmousedown：点击事件
   * 由于用户点击时可能在单元格要循环查找到行，并且是右键点击时，将当前DOM行置位可编辑contenteditable：true，才可进行粘贴操作
   * 如果没有找到tr元素，说明表格没有数据，clickRowIndex=0，复制第一行即可
   * 2.oncontextmenu：右键点击默认事件
   * 右键点击后执行此事件，将contenteditable：false，避免用户编辑表格数据
   * 3.onpaste：粘贴文本事件
   * 从dom元素访问clipboardData对象提供的getData()从剪贴板中取出text（chrome<Mime 类型>中”text”代表”text/plain“）类型的数据
   * 将数据用Parse方法解析为对象，如果解析的内容为Array类型我们才允许粘贴，否则默认为只是普通的文本粘贴，则不执行我们的复制操作
   * 插入操作是在
   */
  onTableRightPaste(tableDom, vue) {
    if (!tableDom) return
    tableDom.onmousedown = (e) => {
      vue.RctDom = e.target
      let pNode = e.target,
        emptyblock = false
      while (!!pNode && pNode.tagName !== 'TR' && !emptyblock) {
        // 支持表格没有数据时，点击表格内空白处可以直接粘贴 点击表头也可以粘贴 用户可能并不清楚
        if (pNode.className && pNode.className.includes('el-table__empty-block')) {
          vue.clickRowIndex = -1
          emptyblock = true
        }
        pNode = pNode.parentNode
      }
      if ((pNode && pNode.tagName === 'TR') || emptyblock) {
        pNode.click() // 执行点击事件是为了获取当前右键所在表格的行数 在crudArrayOrder中搜索tableRowClick事件可查看
        if (e.button === 2) {
          vue.RctDom.style.outline = 'none'
          vue.RctDom.setAttribute('contenteditable', 'true')
        }
      } else {
        vue.clickRowIndex = -1
      }
    }
    tableDom.oncontextmenu = () => {
      setTimeout(() => {
        vue.RctDom.setAttribute('contenteditable', 'false')
      }, 0)
    }
    tableDom.onpaste = (e) => {
      let content = e.clipboardData.getData('Text')
      vue.RctDom.setAttribute('contenteditable', 'false')
      try {
        content = JSON.parse(content)
      } catch (error) {
        console.error(error.message)
      }
      if (Array.isArray(content)) {
        content.forEach((im) => {
          im.id = null
          im._ID = im._ID || objectUtil.createID()
        })
        // 插入数据时插入在当前行的下方
        vue.data.splice(vue.clickRowIndex + 1, 0, ...content)
        if (vue.getTableData) vue.getTableData()
      }
    }
  },
  // 卸载粘贴监听事件
  offTableRightPaste(tableDom) {
    if (!tableDom) return
    tableDom.onmousedown = null
    tableDom.onpaste = null
    tableDom.oncontextmenu = null
  },
}
